import { FeatureFlagContextInterface } from 'contexts/FeatureFlagContextProvider'
import AssetType from 'state/enums/AssetType'

import isLightspeed from './lightspeed'

export const LEGACY_APPLICATION_PATH = '#!/application/new'
export const NEW_APPLICATION_PATH = '#/new-application'
export const NEW_MARINE_APPLICATION = '#/new-marine-app'

const getNewApplicationPath = (
    featureFlags: FeatureFlagContextInterface | null,
    primaryAssetType: AssetType | undefined,
) => {
    if (isLightspeed()) {
        return LEGACY_APPLICATION_PATH
    }

    if (!primaryAssetType) {
        return ''
    }

    if (primaryAssetType === AssetType.AUTOMOBILE) {
        return NEW_APPLICATION_PATH
    }

    if (primaryAssetType === AssetType.MARINE) {
        return NEW_APPLICATION_PATH
    }

    if (primaryAssetType === AssetType.POWERSPORTS_VEHICLE) {
        return NEW_APPLICATION_PATH
    }

    if (primaryAssetType === AssetType.RECREATIONAL_VEHICLE) {
        if (featureFlags?.newRvApp) {
            return NEW_APPLICATION_PATH
        }

        return LEGACY_APPLICATION_PATH
    }

    return LEGACY_APPLICATION_PATH
}

export default getNewApplicationPath
